import { Enums } from './Enums.constant';

export class AppConst {

    public static moduleDefaults = {
        heatingCurveDefault: 26,
    };

    public static thermostats = [Enums.ModuleType.OTH, Enums.ModuleType.BNS, 'BNTH', Enums.ModuleType.NATHERM1, Enums.ModuleType.NATHERMVAILLANT, Enums.ModuleType.BAC, Enums.ModuleType.NAPLUG, Enums.ModuleType.NTE];
    public static fans = [Enums.ModuleType.NLH, Enums.ModuleType.BNFC, Enums.ModuleType.NLLF];
    public static shutters = [Enums.ModuleType.BNMS, Enums.ModuleType.BNAB, Enums.ModuleType.BNAS, Enums.ModuleType.NLIV, Enums.ModuleType.NLLV, 'NLLM', Enums.ModuleType.NLV, Enums.ModuleType.Z3V];

    // need to add this for thermostats not supporting automation
    public static thermostatsAutomation = ['BNTH'];

    // need to add this for shutters not supporting automation
    public static shuttersAutomation = [Enums.ModuleType.BNMS, Enums.ModuleType.NLIV, Enums.ModuleType.NLLV, 'NLLM', Enums.ModuleType.NLV];

    public static heatingDevices = AppConst.thermostats.concat([Enums.ModuleType.NRV, Enums.ModuleType.NVE, Enums.ModuleType.OTM]); // !! Don't forget NLC with applicance type radiator

    public static coolingDevices = [Enums.ModuleType.BNS, Enums.ModuleType.BAC];

    // or appliance type = light
    public static lights = [Enums.ModuleType.NLF, Enums.ModuleType.NLL, Enums.ModuleType.NLFN, Enums.ModuleType.NLM, Enums.ModuleType.NLFE, Enums.ModuleType.NLPT, Enums.ModuleType.Z3L, Enums.ModuleType.NLIS, Enums.ModuleType.BNLD, Enums.ModuleType.BNIL, 'BN3L', Enums.ModuleType.NLFO];

}
